// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nU-w","rootMobile":"styles_rootMobile__1ZhVi"};